<ng-container *ngIf="loader">
  <div style="min-height: 60vh" class="card-body">
    <app-view-details-loader></app-view-details-loader>
  </div>
</ng-container>

<div class="card-body">
  <ng-container *ngIf="!loader">
    <div class="row">
      <div class="col-md-4 col-sm-6">
        <h5>Client Details</h5>
        <div>
          <span class="label-style">Name :</span>

          {{ ViewDetails.client.name }}
        </div>
        <div>
          <span class="label-style">Email :</span>
          {{ ViewDetails.client.email || 'N/A' }}
        </div>
      </div>

      <ng-container
        *ngIf="isQuotationTypeValid() && !ViewDetails.workOrderPage">
        <div class="col-md-4 col-sm-6">
          <h5>Quotation Details</h5>
          <div>
            <span class="label-style"> Number : </span>
            {{ ViewDetails.quotationNumber }}-{{ ViewDetails.revision }}
          </div>

          <div *ngIf="ViewDetails.quoteDate">
            <span class="label-style"> Date :</span>
            {{ ViewDetails.quoteDate | date: constants.DATE_FORMAT }}
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="ViewDetails.workOrderPage">
        <div class="col-md-4 col-sm-6">
          <h5>Work Order Details</h5>
          <div>
            <span class="label-style"> Number : </span>
            {{ ViewDetails.quotationNumber }}-{{ ViewDetails.revision }}
          </div>

          <div *ngIf="ViewDetails.quoteDate">
            <span class="label-style"> Date :</span>
            {{ ViewDetails.quoteDate | date: constants.DATE_FORMAT }}
          </div>
        </div>
      </ng-container>

      <!-- <ng-container *ngIf="quotationDetails.invoiced"> -->
      <div class="col-md-4 col-sm-6" *ngIf="ViewDetails?.invoiceNumber">
        <h5>Invoice Information</h5>
        <div *ngIf="ViewDetails?.invoiceNumber">
          <span class="label-style">Number :</span>
          {{ ViewDetails.invoiceNumber }}
        </div>
        <div *ngIf="ViewDetails?.invoicedDateTime">
          <span class="label-style">Date :</span>
          {{ ViewDetails.invoicedDateTime | date: 'd-MMM-yyyy HH:mm' }}
        </div>
        <div *ngIf="ViewDetails?.serviceDate">
          <span class="label-style">Service Date :</span>
          {{ ViewDetails.serviceDate | date: constants.DATE_FORMAT }}
        </div>

        <p *ngIf="!ViewDetails?.invoiceNumber" class="label-style">
          Not invoiced
        </p>
      </div>
      <div
        class="col-md-4 col-sm-6"
        *ngIf="
          !ViewDetails?.invoiceNumber && ViewDetails?.contract?.contractNumber
        ">
        <h5>Contract Information</h5>
        <div *ngIf="ViewDetails?.contract?.contractNumber">
          <span class="label-style">Number :</span>
          {{ ViewDetails.contract.contractNumber }}-{{
            ViewDetails.contract.revision
          }}
        </div>
        <div *ngIf="ViewDetails?.contract?.date">
          <span class="label-style"> Date :</span>
          {{ ViewDetails.contract.date | date: constants.DATE_FORMAT }}
        </div>

        <p *ngIf="!ViewDetails?.contract?.contractNumber" class="label-style">
          Non Contracted
        </p>
      </div>
      <!-- </ng-container> -->
    </div>
    <ng-container *ngIf="ViewDetails?.legs">
      <h5 class="mt-2">Legs</h5>
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>
                {{ useSalesFlightLabels ? 'Tail Number' : 'Flight Number' }}
              </th>
              <th
                *ngIf="
                  !hideTripNumber &&
                  (useSalesFlightLabels || hasAnyFlightNumber())
                ">
                {{ useSalesFlightLabels ? 'Trip Number' : 'Flight Number' }}
              </th>

              <th>Departure Date</th>
              <th>From</th>
              <th>To</th>
              <th>Arrival Date</th>
              <th>Flight Time</th>
              <th>Lay Over Time</th>
              <th>Hourly Rate</th>
              <th>Pax</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let flight of ViewDetails?.legs">
              <td>{{ flight.aircraft?.tailName }}</td>
              <td
                *ngIf="
                  !hideTripNumber &&
                  (useSalesFlightLabels || hasAnyFlightNumber())
                ">
                <ng-container *ngIf="flight.flightNumber">{{
                  flight.flightNumber
                }}</ng-container>
              </td>
              <td>
                {{
                  dateFormatService.formatUtcDate(
                    flight?.departureDateTime || '',
                    'D-MMM-yyyy HH:mm'
                  )
                }}
                Z
              </td>

              <td>
                {{ flight.fromAirport?.name }},{{ flight?.fromAirport?.city }}
              </td>
              <td>
                {{ flight.toAirport?.name }},{{ flight?.toAirport?.city }}
              </td>

              <td>
                {{
                  dateFormatService.formatUtcDate(
                    flight.arrivalDateTime || '',
                    'D-MMM-yyyy HH:mm'
                  )
                }}
                Z
              </td>

              <td>
                {{ dateFormatService.minutesToTime(flight?.flightTime || 0) }}
              </td>
              <td>
                {{ dateFormatService.minutesToTime(flight.layOverTime || 0) }}
              </td>
              <td>
                {{ ViewDetails.currency.code }}
                {{ flight.hourlyRate | number: '1.2-2' }}
              </td>
              <td>{{ flight.pax }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-container *ngIf="ViewDetails?.additionalCharge">
      <h5 class="mt-2">Additional charges</h5>
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Description</th>
              <th>Amount</th>
              <th>VAT</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody *ngIf="ViewDetails?.additionalCharge">
            <tr *ngFor="let flight of ViewDetails?.additionalCharge">
              <td class="item-desc">{{ flight.itemDescription }}</td>
              <td>{{ flight.unitPrice | number: '1.2-2' }}</td>
              <td>{{ flight.vatAmount | number: '1.2-2' }}</td>
              <td>
                {{
                  calculateTotal(
                    flight.unitPrice,
                    flight?.quantity,
                    flight?.vatAmount
                  ) | number: '1.2-2'
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <!-- line items -->
    <!-- finance ,first/aid,mcc...-->
    <ng-container *ngIf="ViewDetails?.lineItems">
      <h5 class="mt-2">Line Items</h5>
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <td *ngIf="showFirstAidColumns">Date</td>
              <td *ngIf="showFirstAidColumns">Item</td>
              <th>Item Description</th>
              <th>Unit Price</th>
              <!-- show unit for airport module -->

              <ng-container *ngIf="ViewDetails?.lineItems?.[0]?.unit">
                <th>Unit</th>
              </ng-container>
              <!-- ---------------------------- -->

              <th>Qty</th>
              <th>VAT</th>
              <th>Line Amount without Tax</th>
              <th>Line Total({{ ViewDetails.currency.code }})</th>
            </tr>
          </thead>

          <tbody *ngIf="ViewDetails?.lineItems">
            <tr *ngFor="let items of ViewDetails?.lineItems">
              <td *ngIf="showFirstAidColumns">
                {{ items.date | date: constants.DATE_FORMAT }}
              </td>
              <td class="item-name" *ngIf="showFirstAidColumns">
                {{ items.item }}
              </td>
              <td class="item-desc">{{ items.itemDescription }}</td>

              <td>{{ items?.unitPrice | number: '1.2-2' }}</td>

              <!-- show unit for airport module -->
              <ng-container *ngIf="items.unit">
                <td>{{ items?.unit?.name }}</td>
              </ng-container>
              <!-- ---------------------------- -->
              <td>{{ items.quantity }}</td>

              <td>
                {{ items.vatAmount | number: '1.2-2' }}
              </td>

              <td>
                {{ items.totalWithoutTax | number: '1.2-2' }}
              </td>

              <td>
                {{
                  calculateTotal(
                    items?.unitPrice || 0,
                    items?.quantity || 0,
                    items?.vatAmount || 0
                  ) | number: '1.2-2'
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        !ViewDetails?.escortItems?.length &&
        ViewDetails?.invoiceType !== 'CREDIT' &&
        isEscortItem(ViewDetails?.quotationType || '')
      ">
      <h5 class="mt-2">Line Items</h5>
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Item Description</th>
              <th>Unit Price</th>
              <th>Qty</th>
              <th>VAT</th>
              <th>Line Total(SAR)</th>
            </tr>
          </thead>
          <tbody>
            <tr class="text-center">
              <td colspan="5">No items to display</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        !ViewDetails?.lineItems?.length &&
        ViewDetails?.invoiceType === 'CREDIT' &&
        isEscortItem(ViewDetails?.quotationType || '')
      ">
      <h5 class="mt-2">Line Items</h5>
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Item Description</th>
              <th>Unit Price</th>
              <th>Qty</th>
              <th>VAT</th>
              <th>Line Total(SAR)</th>
            </tr>
          </thead>
          <tbody>
            <tr class="text-center">
              <td colspan="5">No items to display</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        ViewDetails?.escortItems &&
        isEscortItem(ViewDetails?.quotationType || '')
      ">
      <h5 class="mt-2">Line Items</h5>
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Item Name</th>
              <th>Item Description</th>
              <th>Cost</th>
              <th>VAT</th>
              <th>Line Total ({{ ViewDetails.currency.code }})</th>
            </tr>
          </thead>
          <tbody *ngIf="ViewDetails?.escortItems">
            <tr *ngFor="let items of ViewDetails?.escortItems">
              <td>
                {{
                  items.type?.toString() ?? 'noitem'
                    | titleCaseWithoutUnderscorePipe
                }}
              </td>
              <td class="item-desc">{{ items.itemDescription }}</td>

              <!-- <ng-container *ngIf="
                  ViewDetails?.currency?.code === 'USD';
                  else unitConvertBlock
                ">
                <td>
                  {{
                  this.currencyConversionService.convertToSAR(
                  items?.unitPrice || 0
                  )
                  }}
                </td>
              </ng-container> -->

              <!-- <ng-template #unitConvertBlock> -->
              <td>{{ items?.unitPrice | number: '1.2-2' }}</td>
              <!-- </ng-template> -->

              <td>{{ items.vatAmount | number: '1.2-2' }}</td>
              <td>
                <!-- <ng-container *ngIf="ViewDetails.currency?.code === 'SAR'; else elseBlock"> -->
                {{
                  calculateTotal(
                    items?.unitPrice || 0,
                    1,
                    items?.vatAmount || 0
                  ) | number: '1.2-2'
                }}
                <!-- </ng-container> -->
                <!-- <ng-template #elseBlock>
                  {{
                  this.currencyConversionService.convertToSAR(
                  calculateTotal(
                  items?.unitPrice || 0,
                  1,
                  items?.vatAmount || 0
                  )
                  ) | number: '1.2-2'
                  }}
                </ng-template> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <div class="row justify-content-end">
      <div class="col-md-6">
        <div class="table-responsive">
          <table class="table">
            <tbody>
              <ng-container *ngIf="ViewDetails?.totalOutOfScope">
                <tr>
                  <td class="font-weight-bold detail-font-style">
                    Total (Excluding VAT) :
                  </td>
                  <td class="detail-font-style">
                    <span *ngIf="ViewDetails?.totalExcludingVat">
                      {{ ViewDetails.currency.code }}
                    </span>
                    {{ ViewDetails.totalExcludingVat | number: '1.2-2' }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold detail-font-style">
                    Total Out Of Scope :
                  </td>
                  <td class="detail-font-style">
                    <span *ngIf="ViewDetails?.totalOutOfScope">
                      {{ ViewDetails.currency.code }}
                    </span>
                    {{ ViewDetails.totalOutOfScope | number: '1.2-2' }}
                  </td>
                </tr>
              </ng-container>
              <tr>
                <td class="font-weight-bold detail-font-style">
                  Total Taxable Amount :
                </td>
                <td class="detail-font-style">
                  <span
                    *ngIf="
                      ViewDetails?.totalExcludingVat ||
                      ViewDetails?.totalOutOfScope
                    ">
                    {{ ViewDetails.currency.code }}
                  </span>
                  {{ getTotalTaxableAmount() | number: '1.2-2' }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold detail-font-style">
                  Total Vat (15%) :
                </td>
                <td class="detail-font-style">
                  <span>
                    {{ ViewDetails.currency.code }}
                  </span>
                  {{ ViewDetails.vatAmount | number: '1.2-2' }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold detail-font-style">Total :</td>
                <td class="detail-font-style">
                  <span *ngIf="ViewDetails?.total">
                    {{ ViewDetails.currency.code }}
                  </span>
                  {{ ViewDetails.total | number: '1.2-2' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <ng-container
      *ngIf="
        ViewDetails.remarks &&
        ViewDetails.quotationType === BusinessType.AirportManagementService
      "
      ><span class="remark-text">
        {{ ViewDetails.remarks }}
      </span></ng-container
    >
  </ng-container>
</div>
